import { InfoCircleFilled, WarningFilled } from '@ant-design/icons';
import clsx from 'clsx';
import React from 'react';

export type InformationBannerVariant = 'banner' | 'text';

export default function InformationBanner({
  className,
  children,
  isAlert = false,
  variant = 'banner',
}: {
  children?: React.ReactNode;
  isAlert?: boolean;
  className?: string;
  variant?: InformationBannerVariant;
}) {
  const isTextVariant = variant === 'text';

  return (
    <span
      className={clsx(
        className,
        'text-sm inline-flex items-center',
        isTextVariant ? 'gap-1.5' : 'p-1.5 gap-2',
        isTextVariant
          ? isAlert
            ? 'text-orange-hellio'
            : 'text-black'
          : isAlert
            ? 'text-gris-hellio bg-orange-clair-hellio'
            : 'text-bleu-hellio bg-bleu-clair-hellio',
      )}
    >
      {isAlert && (
        <WarningFilled
          className={clsx(
            'align-middle',
            !isTextVariant && 'text-orange-hellio',
          )}
        />
      )}
      {!isAlert && !isTextVariant && (
        <InfoCircleFilled className="align-middle" />
      )}
      {children}
    </span>
  );
}
